module.exports = __webpack_public_path__ + "img/funeral_assistence.ada58967.svg";